import { gql } from '@apollo/client';
// src/components/login-query.tsx
// This file contains the GraphQL query for logging in a collection point user.
export const COLLECTIONPOINT_LOGIN = gql`
  query collectionpointLoginByVat($vat: String!, $dispatchNote: String) {
    collectionpointLoginByVat(vat: $vat, dispatchNote: $dispatchNote) {
      jwt
      userMustChangePassword
      expirationDate
      collectionpointId
    }
  }
`;
